/* Stores the user-selected text size in the localstorage. */
const activeClass = `c-site-menu__button--active`;
const buttonClass = 'js-text-size-button';
const namespace = 'dfdigital';
const storageKey = 'fontSize';

function updateButtonState($buttons, fontSize) {
  $buttons.removeClass(activeClass);
  $(`.${buttonClass}-${fontSize}`).addClass(activeClass);
}

function updateTextSize(fontSize) {
  $('.js-text-resize').each(function changeFontSize() {
    const $this = $(this);
    let newFontSize;

    switch (fontSize) {
      case 'large':
        newFontSize = '1.2rem';
        break;
      case 'small':
        newFontSize = '.8rem';
        break;
      default:
        newFontSize = '';
    }

    $this.css('font-size', newFontSize);
  });
}

export default function applyTextsizeClickHandler() {
  const $buttons = $(`.${buttonClass}`);

  if (!Object.prototype.hasOwnProperty.call(window, 'localStorage')) {
    return;
  }

  const fontSize = window.localStorage.getItem(`${namespace}:${storageKey}`);

  updateButtonState($buttons, fontSize);
  updateTextSize(fontSize);

  $buttons.click(function buttonClicked(event) {
    event.preventDefault();
    window.localStorage.setItem(
      `${namespace}:${storageKey}`,
      this.dataset.fontSize
    );

    updateButtonState($buttons, this.dataset.fontSize);
    updateTextSize(this.dataset.fontSize);
  });
}
